import { render } from "./TableAntrianResponsiveWithout.vue?vue&type=template&id=53db0710"
import script from "./TableAntrianResponsiveWithout.vue?vue&type=script&lang=js"
export * from "./TableAntrianResponsiveWithout.vue?vue&type=script&lang=js"

import "./TableAntrianResponsiveWithout.vue?vue&type=style&index=0&id=53db0710&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__